import { AxiosResponse } from 'axios';

const DEFAULT_FILENAME: string = 'download.txt';

export const downloadFileFromResponse = (response: AxiosResponse, fileName?: string): void => {
  const { headers, data, config } = response;
  const contentType = headers['content-type'];
  const responseType = config.responseType;

  downloadFile(data, fileName || getFileNameFromHeaders(headers), contentType, responseType);
};

export const downloadFile = (parts: any, fileName: string, contentType?: string, responseType?: string): void => {
  const data = responseType === 'blob' ? parts : makeBinariesFromContent(parts, contentType);
  const dataUrl = URL.createObjectURL(data);

  const downloadLink = document.createElement('a');
  downloadLink.href = dataUrl;
  downloadLink.setAttribute('download', fileName);

  document.body.appendChild(downloadLink);
  downloadLink.click();
};

const makeBinariesFromContent = (parts: BlobPart, contentType?: string): Blob => {
  return new Blob(Array.isArray(parts) ? parts : [parts], contentType ? { type: contentType } : undefined);
};

// the "content-disposition" header gets removed from api responses when deployed
// and we should look to deprecate this function
const getFileNameFromHeaders = (headers: any): string => {
  const fileName = headers['content-disposition']
    ?.split(' ')
    ?.find((headerPart: string) => headerPart.includes('filename'))
    ?.split('=')[1];

  return fileName || DEFAULT_FILENAME;
};
